import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../users/walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';

const ResourceAccountTimezoneField = ({
    errors,
    touched,
    timezones,
    darkMode,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { autoAttendant } = walkthroughIds;
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = 'ChakraSelect';

    return (
        <FormControl
            isInvalid={!!errors.timezone && touched.timezone}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Timezone <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        The time zone is used for calculating business hours if
                        you create a separate call flow for after hours.
                    </Text>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}>
                    <Field
                        validate={(value) =>
                            !value ? 'Timezone is required' : undefined
                        }
                        name="timezone">
                        {({ form }) => {
                            // Find the selected option object from timezones array
                            const selectedOption =
                                timezones.find(
                                    (tz) => tz.id === form.values.timezone,
                                ) || null;

                            return (
                                <ChakraSelect
                                    minWidth="410px"
                                    width="100%"
                                    data-walkthroughid={
                                        autoAttendant.ufTimezone
                                    }
                                    options={timezones}
                                    placeholder="Select Timezone"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                    getOptionLabel={(i) => i.displayName}
                                    getOptionValue={(i) => i.id}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    isLoading={form.isSubmitting}
                                    isDisabled={form.isSubmitting}
                                    value={selectedOption}
                                    onChange={(item) => {
                                        form.setFieldValue('timezone', item.id);
                                        form.validateField('timezone');
                                    }}
                                    onBlur={() => {
                                        form.setFieldTouched('timezone', true);
                                    }}
                                />
                            );
                        }}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Timezone for creating Auto Attendant."
                        ariaLabel="resource-account-timezone-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ResourceAccountTimezoneField;
